export default {
  name: 'toggle-password',

  ui: {
    input: '[js-toggle-password-input]',
    iconOff: '[js-toggle-password-icon-off]',
    iconOn: '[js-toggle-password-icon-on]',
    button: '[js-toggle-password-button]',
  },

  events: [
    {
      on: 'click',
      target: 'button',
      handle ({ target }) {
        const type = this.ui.input.getAttribute('type') === 'password' ? 'text' : 'password'
        this.ui.input.setAttribute('type', type)

        this.ui.iconOff.classList.toggle('hidden')
        this.ui.iconOn.classList.toggle('hidden')
      },
    },
  ],

  componentDidMount () {
  },
}
